"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n            overflow: hidden;\n            transition: height ", " ease;\n        "], ["\n            overflow: hidden;\n            transition: height ", " ease;\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collapse = function (_Component) {
    _inherits(Collapse, _Component);

    function Collapse(props) {
        _classCallCheck(this, Collapse);

        var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

        _this.state = {
            height: 0
        };
        return _this;
    }

    _createClass(Collapse, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.updateHeight();
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
            if (this.measure.clientHeight != this.state.height) return true;
            return false;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.updateHeight();
        }
    }, {
        key: "updateHeight",
        value: function updateHeight() {
            this.setState({ height: this.measure.clientHeight });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var Collapse = _styledComponents2.default.div(_templateObject, function (props) {
                return props.speed;
            });
            return _react2.default.createElement(
                Collapse,
                {
                    style: { height: this.props.open ? this.state.height : 0 },
                    speed: "1s"
                },
                _react2.default.createElement(
                    "div",
                    { ref: function ref(measure) {
                            return _this2.measure = measure;
                        } },
                    this.props.children
                )
            );
        }
    }]);

    return Collapse;
}(_react.Component);

Collapse.propTypes = {
    speed: _propTypes2.default.string
};

Collapse.defaultProps = {
    speed: "1s"
};

exports.default = Collapse;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/collapse.js
// module id = 994
// module chunks = 95715928098905 168707334958949